import { type ParentRegistrationColumnMappingTableData } from '~pages/parents/bulk-upload/types';

export const TABLE_DATA: Array<ParentRegistrationColumnMappingTableData> = [
  // Parent Information
  {
    header: 'Parent First Name',
    sample: 'John',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Parent Last Name',
    sample: 'Doe',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Parent Email',
    sample: 'john.doe@example.com',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Parent Primary Phone',
    sample: '1234567890',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Relation',
    sample: 'Father',
    selectedColumn: '',
    columnValue: '',
  },

  // Address Information
  {
    header: 'Address Apartment',
    sample: 'Apt 123',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Address Street',
    sample: '123 Main St',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Address City',
    sample: 'New York',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Address State',
    sample: 'NY',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Address Zip',
    sample: '12345',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Address Country',
    sample: 'USA',
    selectedColumn: '',
    columnValue: '',
  },

  // Emergency Contact Information
  {
    header: 'Emergency Contact 1 First Name',
    sample: 'Jane',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Emergency Contact 1 Last Name',
    sample: 'Smith',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Emergency Contact 1 Primary Phone',
    sample: '1234567890',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Emergency Contact 1 Email',
    sample: 'jane.smith@example.com',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Emergency Contact 1 Authorize Pickup',
    sample: 'Yes',
    selectedColumn: '',
    columnValue: '',
  },

  // Student 1 Information (Required)
  {
    header: 'Student 1 First Name',
    sample: 'Alice',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 1 Last Name',
    sample: 'Doe',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 1 Date of Birth',
    sample: '07-08-2015',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 1 Gender',
    sample: 'Female',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 1 Email',
    sample: 'alice.doe@example.com',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 1 Primary Phone',
    sample: '1234567890',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 1 Costume Size',
    sample: 'Medium',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 1 Transportation',
    sample: 'Bus',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 1 Health Insurance Carrier',
    sample: 'Blue Cross',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 1 Primary Doctor',
    sample: 'Dr. Smith',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 1 Allergies',
    sample: 'None',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 1 Disabilities',
    sample: 'None',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 1 Medications',
    sample: 'None',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 1 Special Needs',
    sample: 'None',
    selectedColumn: '',
    columnValue: '',
  },

  // Student 2 Information (Optional)
  {
    header: 'Student 2 First Name',
    sample: 'Bob',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 2 Last Name',
    sample: 'Doe',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 2 Date of Birth',
    sample: '02-05-2016',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 2 Gender',
    sample: 'Male',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 2 Email',
    sample: 'bob.doe@example.com',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 2 Primary Phone',
    sample: '1234567890',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 2 Costume Size',
    sample: 'Large',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 2 Transportation',
    sample: 'Bus',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 2 Health Insurance Carrier',
    sample: 'Blue Cross',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 2 Primary Doctor',
    sample: 'Dr. Smith',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 2 Allergies',
    sample: 'None',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 2 Disabilities',
    sample: 'None',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 2 Medications',
    sample: 'None',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 2 Special Needs',
    sample: 'None',
    selectedColumn: '',
    columnValue: '',
  },

  // Student 3 Information (Optional)
  {
    header: 'Student 3 First Name',
    sample: 'Charlie',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 3 Last Name',
    sample: 'Doe',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 3 Date of Birth',
    sample: '11-03-2017',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 3 Gender',
    sample: 'Female',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 3 Email',
    sample: 'charlie.doe@example.com',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 3 Primary Phone',
    sample: '1234567890',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 3 Costume Size',
    sample: 'Small',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 3 Transportation',
    sample: 'Car',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 3 Health Insurance Carrier',
    sample: 'UnitedHealthcare',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 3 Primary Doctor',
    sample: 'Dr. Adams',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 3 Allergies',
    sample: 'None',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 3 Disabilities',
    sample: 'Dyslexia',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 3 Medications',
    sample: 'None',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 3 Special Needs',
    sample: 'Reading Assistance',
    selectedColumn: '',
    columnValue: '',
  },

  // Student 4 Information (Optional)
  {
    header: 'Student 4 First Name',
    sample: 'David',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 4 Last Name',
    sample: 'Doe',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 4 Date of Birth',
    sample: '05-09-2018',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 4 Gender',
    sample: 'Male',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 4 Email',
    sample: 'david.doe@example.com',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 4 Primary Phone',
    sample: '1234567890',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 4 Costume Size',
    sample: 'Medium',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 4 Transportation',
    sample: 'Car',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 4 Health Insurance Carrier',
    sample: 'UnitedHealthcare',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 4 Primary Doctor',
    sample: 'Dr. Adams',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 4 Allergies',
    sample: 'Shellfish',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 4 Disabilities',
    sample: 'None',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 4 Medications',
    sample: 'None',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 4 Special Needs',
    sample: 'None',
    selectedColumn: '',
    columnValue: '',
  },

  // Student 5 Information (Optional)
  {
    header: 'Student 5 First Name',
    sample: 'Eve',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 5 Last Name',
    sample: 'Doe',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 5 Date of Birth',
    sample: '05-09-2018',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 5 Gender',
    sample: 'Female',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 5 Email',
    sample: 'eve.doe@example.com',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 5 Primary Phone',
    sample: '1234567890',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 5 Costume Size',
    sample: 'Large',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 5 Transportation',
    sample: 'Car',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 5 Health Insurance Carrier',
    sample: 'Aetna',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 5 Primary Doctor',
    sample: 'Dr. Carter',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 5 Allergies',
    sample: 'Latex',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 5 Disabilities',
    sample: 'ADHD',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 5 Medications',
    sample: 'Ritalin',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Student 5 Special Needs',
    sample: 'Behavioral Therapy',
    selectedColumn: '',
    columnValue: '',
  },
];
